import { startOfDay } from 'date-fns';

/**
 * Checks if a buyer agreement is expired based on its end date.
 *
 * If a reference date is provided, the agreement is considered expired
 * if it ended before the reference date. Otherwise, the current date is
 * used.
 *
 * @param endDate - The end date string in yyyy-MM-dd format or null
 * @param referenceDate - The reference date to use for the comparison
 * @returns true if the agreement is expired, false otherwise
 */
export function isAgreementExpired(
  endDate: string | null,
  referenceDate?: Date,
): boolean {
  if (!endDate) {
    return false;
  }

  try {
    // Note: Must add T00:00:00 to interpet date in local timezone
    const endDateObj = startOfDay(new Date(`${endDate}T00:00:00`));
    const referenceDateObj = startOfDay(referenceDate ?? new Date());

    return endDateObj < referenceDateObj;
  } catch {
    return false;
  }
}
